
import React from 'react';
import './styledsk.css';
import logo from '../../assets/img/Sobr.png';
import couple from '../../assets/ambassadors/couple.png';
import world from '../../assets/ambassadors/world.png';
import asian2 from '../../assets/ambassadors/backgroundasian.png';
import arrow from '../../assets/img/arrow.svg';
import vector5 from '../../assets/ambassadors/Vector5.svg';
import midias from '../../assets/img/Social Media.svg';
import vector10 from '../../assets/ambassadors/vector10.svg';
import vector11 from '../../assets/ambassadors/Vector11.svg';
import vector12 from '../../assets/ambassadors/Vector12.svg';
import vector6 from '../../assets/img/Vector6.png';
import { useNavigate } from 'react-router-dom';



const Ambassadors = () => {

    const scrollToMenu = () => {
        const menuElement = document.querySelector('.logo2');
        if (menuElement) {
            menuElement.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
    <>
    <header className="header-containerx">
    <div className="header-left">
                <img className='logo2'src={logo} alt="Logo" height='70px' />
            </div>
            <nav className="header-nav">
                <a href="/es">Home</a>
                <a href="/embajadores">Embajadores</a>
                <a href="/equiposobr">Equipo Sobr</a>
                <a href="/terminosypolitica">Términos y Políticas</a>
            </nav>
            <div className="header-right">
            <a className='butontranslate' href="/">en-US</a>
            <a className='butontranslate' href="/br">pt-BR</a>
            </div>
            <div className="header-right">
            </div>
        </header>
        <body>
                <div className="iphone4">
                    <main>
                    <section className="hero5">
                        <h1>Embajadores de Sobr</h1>
                        <p>Nuestros Embajadores de Sobr son los corazones y las mentes detrás de la revolución de la felicidad en Sobr. Como apasionados defensores de la sobriedad, encarnan los valores de autenticidad, salud y conexiones genuinas que hacen que Sobr sea único.                        </p>                   
                        <button className="demo-button">DESCARGAR AHORA</button>
                    </section>
                    </main>
                </div>
                
                <div className="content11dsk">
                    <img className='match2' src={world} alt="match" title="match" height="500" />  
                    <section>       
                        <h1>Lo que hacen nuestros Embajadores</h1>
                        <p> <strong>Inspirar:</strong> Nuestros embajadores comparten sus historias personales de transformación y crecimiento, inspirando a otros a abrazar la sobriedad como un estilo de vida positivo y gratificante.
<strong> Conectar: </strong>Son constructores de puentes, uniendo a las personas y las comunidades en torno a la misión de Sobr para crear un mundo más feliz y más saludable, libre del estigma asociado con la sobriedad.
<strong> Educar:</strong> Nuestros embajadores son educadores comprometidos, proporcionando valiosos recursos e información sobre los beneficios de la sobriedad y el apoyo disponible en la comunidad Sobr.</p>
                    </section>
                </div>
                <div className='div5'></div>
                <div className="content10dsk">
                <img className='asian2' src={asian2} alt="match" title="match" height="500" /> 
                </div>
                <div className='xxxx'>
                    <section>       
                        <h1>Por qué ser Embajador:</h1>
                        <p> <strong>Impacto:</strong> Sea parte de una comunidad global que está cambiando vidas y desafiando las percepciones sobre la sobriedad. Como Embajador, usted tendrá la oportunidad de hacer una diferencia significativa en la vida de otras personas.
<br></br> <strong>Apoyo:</strong> Recibir apoyo del equipo de Sobr y otros embajadores mientras navegas tu propio viaje de sobriedad y ayudas a otros en el suyo.
<strong>Reconocimiento::</strong> Serás reconocido como líder de opinión y defensor de la sobriedad, aparecerás en nuestras plataformas y eventos, y formarás parte de una red exclusiva de embajadores globales.
                        </p>
                    </section>
                    </div>
{/* 
                <div className="content8dsk">
                    <h1>What our happy customers are saying</h1>
                </div>
                <div className='reviewsdsk'>
                <div className="review-boxdsk">
                    <div className="header2dsk">
                        <h3>Margie V.</h3>
                        <p>Montevideo</p>
                    </div>
                    <div className="starxdsk">
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="time">2 months ago</span>
                    </div>
                    <div className="contentdsk">
                        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
                    </div>
                    <div className="verifieddsk">
                        <span>Verified by</span>
                    </div>
                </div>
                <div className="review-boxdsk">
                    <div className="header2dsk">
                        <h3>Margie V.</h3>
                        <p>Montevideo</p>
                    </div>
                    <div className="starxdsk">
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="time">2 months ago</span>
                    </div>
                    <div className="contentdsk">
                        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
                    </div>
                    <div className="verifieddsk">
                        <span>Verified by</span>
                    </div>
                </div>
                <div className="review-boxdsk">
                    <div className="header2dsk">
                        <h3>Margie V.</h3>
                        <p>Montevideo</p>
                    </div>
                    <div className="starxdsk">
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="time">2 months ago</span>
                    </div>
                    <div className="contentdsk">
                        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
                    </div>
                    <div className="verifieddsk">
                        <span>Verified by</span>
                    </div>
                </div>
                </div> */}
                <footer>
                    <div className="footer-contentdsk">
                        <p>Termos de Servicio | Política de Privacidad</p>
                    </div>
                    <div className="footer-copyrightdsk">
                    &copy; 2024 Sobr Inc., Todos los Derechos Reservados   
                    </div>
                    {/* Ícone da seta para rolar até o menu principal */}
                    <div onClick={scrollToMenu} style={{ cursor: 'pointer', marginTop: '20px' }}>
                        <img src={arrow} height="24" width="24" alt="scroll to top" title="scroll to top" />
                    </div>
                </footer>

        </body>     
    </>
        );
    };
export default Ambassadors;
